import {investment, propertyOffer, removeRedundantWhiteSpaces} from "@pg-mono/string-utils";

import {BRAND_NAME} from "../../app/constants/company";
import {PromotionType} from "../../promotion/helpers/PromotionType";

export interface IDescriptionPromotionList {
    count: number;
    region?: string;
    type?: PromotionType;
    page?: number;
}

export const descriptionPromotionList = ({count = 0, region, type = PromotionType.PROMOTION, page}: IDescriptionPromotionList): string => {
    const regionSuffix = region ? ` ${region}` : "";
    const pageSuffix = typeof page === "number" && page > 1 ? ` - Strona ${page}` : "";
    const offerNominative = propertyOffer.nominative(count);
    const offerAccusative = propertyOffer.accusative(count);

    let description: string;

    switch (type) {
        case PromotionType.OPEN_DAYS:
            description = `${count} ${offerNominative} dni otwartych deweloperów${regionSuffix} - odwiedź inwestycje i obejrzyj mieszkania bez zobowiązań. Sprawdź na ${BRAND_NAME}${pageSuffix}!`;
            break;
        case PromotionType.DISCOUNT:
            description = `${count} ${offerNominative} przecenionych mieszkań od deweloperów${regionSuffix} - nowe lokale w niższej cenie na rynku pierwotnym. Oszczędź na zakupie. Sprawdź na ${BRAND_NAME}${pageSuffix}!`;
            break;
        case PromotionType.LAST_MINUTE:
            description = `${count} ${offerNominative} last minute od deweloperów${regionSuffix} - ostatnie wolne mieszkania w obniżonej cenie. Działaj szybko i znajdź swoją okazję na ${BRAND_NAME}${pageSuffix}!`;
            break;
        case PromotionType.PRESALE:
            description = `Mieszkania w przedsprzedaży od deweloperów${regionSuffix} - kup taniej na etapie projektu i wybierz najlepszy lokal. Przeglądaj ${count} ${offerAccusative} na ${BRAND_NAME}${pageSuffix}!`;
            break;
        case PromotionType.NO_CONTRIBUTION:
            description = `${count} ${investment.nominative(count)} mieszkań bez wkładu własnego od deweloperów${regionSuffix}. Skorzystaj z Rodzinnego Kredytu Mieszkaniowego. Sprawdź warunki i porównaj oferty na ${BRAND_NAME}${pageSuffix}!`;
            break;
        case PromotionType.PROMOTION:
        default:
            description = `Aktualne promocje na nowe mieszkania deweloperskie${regionSuffix}. Rabaty, oferty z miejscem postojowym w cenie lub pakiety wykończeniowe gratis. Sprawdź ${count} ${offerAccusative} na ${BRAND_NAME}${pageSuffix}!`;
            break;
    }

    return removeRedundantWhiteSpaces(description);
};
import {investment, propertyOffer, removeRedundantWhiteSpaces} from "@pg-mono/string-utils";

import {BRAND_NAME} from "../../app/constants/company";
import {PromotionType} from "../../promotion/helpers/PromotionType";

export interface IDescriptionPromotionList {
    count: number;
    region?: string;
    type?: PromotionType;
    page?: number;
}

export const descriptionPromotionList = ({count = 0, region, type = PromotionType.PROMOTION, page}: IDescriptionPromotionList): string => {
    const regionSuffix = region ? ` ${region}` : "";
    const pageSuffix = typeof page === "number" && page > 1 ? ` - Strona ${page}` : "";
    const offerNominative = propertyOffer.nominative(count);
    const offerAccusative = propertyOffer.accusative(count);

    let description: string;

    switch (type) {
        case PromotionType.OPEN_DAYS:
            description = `${count} ${offerNominative} dni otwartych deweloperów${regionSuffix} - odwiedź inwestycje i obejrzyj mieszkania bez zobowiązań. Sprawdź na ${BRAND_NAME}${pageSuffix}!`;
            break;
        case PromotionType.DISCOUNT:
            description = `${count} ${offerNominative} przecenionych mieszkań od deweloperów${regionSuffix} - nowe lokale w niższej cenie na rynku pierwotnym. Oszczędź na zakupie. Sprawdź na ${BRAND_NAME}${pageSuffix}!`;
            break;
        case PromotionType.LAST_MINUTE:
            description = `${count} ${offerNominative} last minute od deweloperów${regionSuffix} - ostatnie wolne mieszkania w obniżonej cenie. Działaj szybko i znajdź swoją okazję na ${BRAND_NAME}${pageSuffix}!`;
            break;
        case PromotionType.PRESALE:
            description = `Mieszkania w przedsprzedaży od deweloperów${regionSuffix} - kup taniej na etapie projektu i wybierz najlepszy lokal. Przeglądaj ${count} ${offerAccusative} na ${BRAND_NAME}${pageSuffix}!`;
            break;
        case PromotionType.NO_CONTRIBUTION:
            description = `${count} ${investment.nominative(count)} mieszkań bez wkładu własnego od deweloperów${regionSuffix}. Skorzystaj z Rodzinnego Kredytu Mieszkaniowego. Sprawdź warunki i porównaj oferty na ${BRAND_NAME}${pageSuffix}!`;
            break;
        case PromotionType.PROMOTION:
        default:
            description = `Aktualne promocje na nowe mieszkania deweloperskie${regionSuffix}. Rabaty, oferty z miejscem postojowym w cenie lub pakiety wykończeniowe gratis. Sprawdź ${count} ${offerAccusative} na ${BRAND_NAME}${pageSuffix}!`;
            break;
    }

    return removeRedundantWhiteSpaces(description);
};
